export enum PaymentsSearchField {
    groupName = 'groupName',
    organization = 'organization',
    practitioner = 'practitioner',
    processId = 'processId',
    relationNumber = 'relationNumber',
    txcsProcesId = 'txcsProcesId',
}
